import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { articleJakZaczac } from '@/mocks/articles';

export default function ArticleJakZaczac() {
  return <ArticleTemplate data={articleJakZaczac} />;
}